﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import NoteViewer from '../NoteViewer';
import TasksGanttComponent from './TasksGanttComponent'; 
import { User } from '../../models/user';
import { Department } from '../../models/department';
import { DmaTask } from '../../models/DmaTasks/dma-task';
import { TaskType } from '../../models/DmaTasks/task-type';
import { TaskTypeParameter } from '../../models/DmaTasks/task-type-parameter';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, NoteType } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { ToastProps } from '../../models/toast-props';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import DmaFooter from '../DmaFooter';
import TicketLogEntryForm from '../TicketLogEntryForm';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    Button as ColumnButton,
    HeaderFilter,
    Toolbar,
    Popup,
    Form,
    Lookup,
    Item as ToolbarItem,
    Editing,
    Paging,
    Pager,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';
import Button from 'devextreme-react/button';
import Toast from 'devextreme-react/toast';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;

export default function TasksForm() {
    const [tasks, setTasks] =
        useState<DmaTask[]>();

    const [selectedTask, setSelectedTask] =
        useState<DmaTask>();

    const [taskTypes, setTaskTypes] =
        useState<TaskType[]>();

    const [users, setUsers] =
        useState<User[]>();

    const [departments, setDepartments] =
        useState<Department[]>();

    const [taskTypeParameters, setTaskTypeParameters] =
        useState<TaskTypeParameter[]>();

    const [selectedTaskTypeParameter, setSelectedTaskTypeParameter] =
        useState<TaskTypeParameter>();

    const [taskCategories, setTaskCategories] =
        useState<LookupItem[]>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    useEffect(() => {
        getAllData();
    }, []);

    key++;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Tasks Scheduling</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="16rem"
                    dataSource={tasks ? tasks : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="taskId"
                    onSelectionChanged={onTasksSelectionChanged}
                    onRowValidating={onTasksRowValidating}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={30} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={[30, 60, 100]}
                        showInfo={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width="8rem">
                        <ColumnButton name="edit" />
                        <ColumnButton hint="audit information" icon="clock"
                            onClick={onTaskAuditButtonClicked} />
                        <ColumnButton hint="information" icon="info"
                            onClick={onTaskInformationButtonClicked} />
                        <ColumnButton name="delete" />
                    </Column>

                    <Column dataField='name' dataType='string' width='10rem' />
                    <Column dataField='taskTypeId' caption="Task Type" dataType='string' width='10rem'>
                        <Lookup dataSource={taskTypes ? taskTypes  : []}
                            displayExpr='name' valueExpr='taskTypeId' />
                    </Column>

                    <Column dataField='assignedBy' dataType='string' width='10rem' allowEditing={false}>
                        <Lookup dataSource={users ? users : []}
                            allowClearing={false}
                            displayExpr={(data) => { return data ? `${data.firstName} ${data.lastName}` : '' }} valueExpr='userId' />
                    </Column>

                    <Column dataField='assignedTo' dataType='string' width='10rem'>
                        <Lookup dataSource={users ? users : []}
                            allowClearing={true}
                            displayExpr={(data) => { return data ? `${data.firstName} ${data.lastName}` : '' } } valueExpr='userId' />
                    </Column>

                    <Column dataField='departmentAssignedTo' caption='Department' dataType='string' width='10rem'>
                        <Lookup dataSource={departments ? departments : []}
                            allowClearing={true}
                            displayExpr='name' valueExpr='departmentId' />
                    </Column>

                    <Column dataField='startDate' dataType='date' width='8rem' />
                    <Column dataField='duration' caption="Duration(hours)" dataType='number' width='8rem' />

                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Tasks</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location='after' name="searchPanel" />
                        <ToolbarItem location='after' name="addRowButton" />
                    </Toolbar>

                    <Editing mode="popup"
                        useIcons={true}
                        allowAdding={true}
                        allowUpdating={true}
                        allowDeleting={true}>

                        <Popup title="Edit Task" showTitle={true} width="55rem" height="25rem" />
                        <Form>
                            <Item dataField="name" />
                            <Item dataField="taskTypeId" />
                            <Item dataField="assignedTo" />
                            <Item dataField="departmentAssignedTo" />
                            <Item dataField="startDate" />
                            <Item dataField="duration" />
                        </Form>ss
                    </Editing>

                </DataGrid>
            </div>
            
            <div className="pw-margin-top-1">
                <NoteViewer height='8rem' title="Task Description" headerColor="pw-bg-blue"
                    noteType={NoteType.TaskDescription}
                    parentId={selectedTask && selectedTask.taskId ? selectedTask.taskId : null} />
            </div>            

            <div>
                <TasksGanttComponent height={400} taskListWidth={500} />
            </div>

            <DmaFooter />

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Task Forms" contextData={selectedTask}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function onTasksSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedTask(e.selectedRowsData[0]);
    }

    async function onTasksRowValidating(e: any) {
        if (e.oldData) {
            let task = e.oldData as DmaTask;

            if (task) {
                let updatedTask = { ...task, ...e.newData };

                await updateTask(updatedTask)
                    .then(() => {
                        showToast("Task updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Task");
                    });
            }
        }
        else {
            if (e.newData) {
                let task = e.newData as DmaTask;

                await insertTask(task)
                    .then(() => {
                        showToast("Task saved", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Task");
                    });
            }
        }
    }

    async function getTaskTypes() {
        await CrudFunctions.getData("dmatasks/tasktypes")
            .then((data) => {
                setTaskTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Task Types");
            });
    }

    async function getTasks() {
        await CrudFunctions.getData(`dmatasks/tasks`)
                .then((data) => {
                    setTasks(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Tasks");
                });
    }

    async function getAllUsers() {
        await CrudFunctions.getData("common/activeuserslist")
            .then((data) => {
                setUsers(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Active Users");
            });
    }

    async function getDepartments() {
        await CrudFunctions.getData("common/departmentslist")
            .then((data) => {

                console.log(data);

                setDepartments(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Departments");
            });
    }

    async function getTaskCategories() {
        await CrudFunctions.getData("common/taskcategories")
            .then((data) => {
                //setTaskCategories(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Task Categories");
            });
    }

    async function insertTask(task: DmaTask) {
        return await CrudFunctions.postData("dmatasks/task", task);
    }

    async function updateTask(task: DmaTask) {
        return await CrudFunctions.putData("dmatasks/task", task);
    }

    async function getAllData() {
        await Promise.all([
            //getTaskCategories(),
            getAllUsers(),
            getDepartments(),
            getTaskTypes(),
            getTasks()
        ]);
    }

    //navigation
    function goBack() {
        history.back();
    }



    function onTaskAuditButtonClicked(e: any) {


    }


    //other
    function onTaskInformationButtonClicked(e: any) {

        console.log("onTaskInformationButtonClicked-----------------");
        console.log(e);

        if (e.row && e.row.data) {
            const task = e.row.data as DmaTask;

            if (task) {
                setSelectedTask(task);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: task.taskId,
                    createTimestamp: task.createTimestamp,
                    lastModifiedTimestamp: task.modifyTimestamp,
                    createUser: task.createUser,
                    modifyUser: task.modifyUser
                };

                console.log("RESULT:");
                console.log(itemInformation);

                setItemBasicInformation(itemInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }
}